var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useDraggable, useDroppable, TableRow, TableBodyCell, TableCellText } from '@pocketlaw/tetris';
import { ContextMenuCell, DateCell, EmptyCell, NameCell } from './TableCells';
function FolderTableRow(props) {
    const { id, type, name, date, onRename, onDelete, onEditAccess, onQuickMove, onMove, accessLevel } = props, restProps = __rest(props, ["id", "type", "name", "date", "onRename", "onDelete", "onEditAccess", "onQuickMove", "onMove", "accessLevel"]);
    const openUrl = `/files/${id}`;
    const { droppableProps, isDraggingOver } = useDroppable(onQuickMove);
    const { draggableProps, isDragging } = useDraggable(`${type}:${id}`);
    const canEdit = accessLevel === 'full';
    const tableRowProps = Object.assign(Object.assign(Object.assign({ $isDraggable: canEdit, $isDragging: isDragging, $isDraggingOver: !isDragging && isDraggingOver }, (canEdit ? draggableProps : {})), (canEdit ? droppableProps : {})), restProps);
    const folderType = canEdit ? 'folder' : 'folder:locked';
    return (<TableRow {...tableRowProps}>
      <NameCell headers="filesystemtable-name" to={openUrl} title={name} type={folderType}/>
      <TableBodyCell headers="filesystemtable-status">
        <TableCellText primary=""/>
      </TableBodyCell>
      <DateCell headers="filesystemtable-updatedAt" date={date}/>
      <EmptyCell headers="filesystemtable-contractOwner"/>
      <ContextMenuCell accessLevel={accessLevel} download={false} openUrl={openUrl} onRename={onRename} onDelete={onDelete} onEditAccess={onEditAccess} onMove={onMove}/>
    </TableRow>);
}
FolderTableRow.displayName = 'FolderTableRow';
export default FolderTableRow;
